import dayjs from 'dayjs'
import { ascending } from 'd3'
import { formatNumber } from '@local_modules/flokit'

import { fillString } from '@local_modules/generic/string-template.js'
import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links.js'
import { outputChartOfAccountText } from '../output-chart-of-account-text.js'
import { getEntityShortcode } from '../helpers/get-entity-shortcode.js'

export default function makeColumnDefsForAccounts (context) {
  const columnDefs = []

  const timeframeCoverage = computeTimeframeCoverage(context)

  columnDefs.push({
    headerName: 'Statement',
    valueGetter: function (cellParams) {
      return cellParams.data?.chartOfAccount?.chart_of_account_statement
    },
    pinned: 'left'
  })

  // Chart of Account
  columnDefs.push({
    headerName: 'Account',
    valueGetter: function (cellParams) {
      return outputChartOfAccountText(cellParams.data?.chartOfAccount)
    },
    cellRenderer: function (cellParams) {
      const outputTemplate = ':accountText [<a href=":urlToXero" target="_blank">Xero</a>]'

      // TODO: manage when multiple entities
      const shortCode = getEntityShortcode(cellParams.context, context.showOrgId)

      const urlToXero = makeXeroLink('ReportAccountTransactions', {
        shortCode,
        xeroAccountId: cellParams.data.chart_of_account_xero_id,
        fromISOdate: timeframeCoverage.from,
        toISOdate: timeframeCoverage.to
      })

      return fillString(outputTemplate, {
        accountText: cellParams.value,
        urlToXero
      })
    },
    width: 200,
    pinned: 'left'
  })

  const monthsColumns = makeMonthsColumns(timeframeCoverage.monthsArray)
  columnDefs.push(...monthsColumns)

  return columnDefs
}

/**
 *
 * @param {*} context
 * @returns
 */
function computeTimeframeCoverage (context) {
  const journalsData = context.data?.journalsData

  const months = new Set()
  journalsData?.forEach(function (oneEntry) {
    const month = dayjs(oneEntry.journal_date).format('YYYY-MM')
    months.add(month)
  })

  const monthsArray = Array.from(months)
  monthsArray?.sort(function (m1, m2) {
    return ascending(m1, m2)
  })

  const timeframeCoverage = {
    from: dayjs(monthsArray[0]).startOf('month').format('YYYY-MM-DD'),
    to: dayjs(monthsArray[monthsArray.length - 1]).endOf('month').format('YYYY-MM-DD'),
    monthsArray
  }

  return timeframeCoverage
}

/**
 *
 * @param {*} context
 * @returns
 */
function makeMonthsColumns (monthsArray) {
  const monthColDefs = []
  monthsArray?.forEach(function (oneMonth) {
    const colDef = {
      headerName: dayjs(oneMonth).format('MMM YYYY'),
      context: {
        month: oneMonth
      },
      type: 'numericColumn',
      valueGetter: function (cellParams) {
        const targetMonth = cellParams.colDef.context.month

        const cellValues = cellParams.data.values?.filter(function (value) {
          const valueMonth = dayjs(value.journal_date).format('YYYY-MM')
          return valueMonth === targetMonth
        })
        if (!cellValues) return null

        let value = 0
        cellValues.forEach(function (cellValue) {
          value += parseFloat(cellValue?.amount) || 0
        })

        return value
      },
      valueFormatter: function (cellParams) {
        if (!cellParams.value) return null

        return formatNumber(cellParams.value, 2)
      }
    }
    monthColDefs.push(colDef)
  })

  return monthColDefs
}
